export default __webpack_public_path__ + "static/media/geth-bg.ab31d24b.png";